import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable, startWith } from 'rxjs';
import { AsyncPipe, DatePipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { HOUR_MINUTE_FORMAT } from '@properties/date-time.properties';
import { ConvertDatePipe } from '@pipes/convert-date/convert-date.pipe';
import { TimezoneInterface } from '@interfaces/timezone/timezone.interface';
import { TimezoneSharedService } from '@services/timezone/timezone-shared.service';
import { TimezoneChangeEvent } from '@interfaces/timezone/timezone-change-event.interface';
import { TimezoneAbbreviationPipe } from '@pipes/timezone-abbreviation/timezone-abbreviation.pipe';
import { NotificationComponent } from '@modules/notification-queue/abstract/notification.component';
import { ServiceRequestCreatedSignalRInterface } from '@interfaces/singnal-r/service-request-created-signal-r.interface';
import { DsNotificationComponent } from '@design-system/ds-notification/component/ds-notification.component';
import { INTERNAL_SERVICE_REQUEST_EDIT_PATH } from 'src/app/pages/v2/service-request/properties/internal-service-request-routes.properties';

@Component({
  selector: 'app-service-request-notification',
  standalone: true,
  templateUrl: './service-request-notification.component.html',
  styleUrls: ['./service-request-notification.component.scss'],
  imports: [NgIf, AsyncPipe, ConvertDatePipe, DatePipe, TimezoneAbbreviationPipe, DsNotificationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceRequestNotificationComponent extends NotificationComponent {
  @Input() override notification: ServiceRequestCreatedSignalRInterface | null = null;

  protected readonly HOUR_MINUTE_FORMAT = HOUR_MINUTE_FORMAT;

  timezone$: Observable<TimezoneInterface> = this.timezoneSharedService.timezoneChange.pipe(
    map((changeEvent: TimezoneChangeEvent) => changeEvent.timezone),
    startWith(this.timezoneSharedService.selectedTimezone),
  );

  constructor(
    router: Router,
    private readonly timezoneSharedService: TimezoneSharedService,
  ) {
    super(router);
  }

  /**
   * Navigates to the edit service request page to view the specified service request.
   */
  override async onViewServiceRequest(): Promise<void> {
    return super.onViewServiceRequest(
      this.notification.serviceRequestId,
      this.notification.notificationId,
      `${INTERNAL_SERVICE_REQUEST_EDIT_PATH}/`,
    );
  }

  /**
   * Close the notification window
   */
  override closeNotification(): void {
    super.closeNotification(this.notification.notificationId);
  }
}
